import { axiosRequest } from "@planbord/axios-request";
import { useQuery } from "@tanstack/vue-query";
import { SelectOption } from "@planbord/shared/models";

export const useListVehicleSelectOptions = () => {
  const baseUrl = "/api";

  return useQuery<SelectOption[]>({
    queryKey: ["listVehicleSelectOptions"],
    queryFn: () =>
      axiosRequest.get(`${baseUrl}/listVehicleSelectOptions`).then((res) =>
        res.data
          .map((option: SelectOption) => ({
            ...option,
            Label: option.Label === "04651" ? "651" : option.Label,
          }))
          .sort((a: SelectOption, b: SelectOption) => {
          // Keep "-" at the top
          if (a.Label === "-") return -1;
          if (b.Label === "-") return 1;
          // Sort the rest alphabetically
          return a.Label.localeCompare(b.Label);
        })
      ),
    // Use the cache for 60 minutes
    staleTime: 60 * 60000,
  });
};
